<div class="wrapper-md">
    <app-breadcrumbs [items]="[
                     { url: '/notification-templates', text: 'notificationTemplate_listTitle' },
                     {
                        url: '/notification-templates/' + (isNew ? 'add' : data.Id),
                        text: isNew ? 'notificationTemplate_newTitle' : 'notificationTemplate_editTitle'
                     }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>
            {{isNew ? ('notificationTemplate_newTitle' | translate) : (name || '...')}}
        </h1>
    </header>

    <form #form="ngForm" [class.was-validated]="isFormSubmitted">
        <div class="row">
            <div class="col-sm-8">
                <div class="form-field required">
                    <label class="form-label">{{'notificationTemplate_lblName' | translate}}</label>
                    <input class="form-control" [(ngModel)]="model.Name" name="name" required #nameInput="ngModel" />
                    <div class="feedback" [class.invalid-feedback]="isFormSubmitted && validations.name.pattern">{{'notificationTemplate_hintName' | translate}}</div>
                    <div class="invalid-feedback" *ngIf="isFormSubmitted && validations.name.required">
                        {{requiredError}}
                    </div>
                    <div class="invalid-feedback" *ngIf="isFormSubmitted && validations.name.maxlength">
                        {{getMaxLengthError(maxLengths.name)}}
                    </div>
                </div>
            </div>

            <div class="col-sm-4">
                <div class="form-field required">
                    <label class="form-label">{{'notification_lblType' | translate}}</label>
                    <app-select [(ngModel)]="model.TypeId"
                                [options]="options.type"
                                [valueProperty]="'value'"
                                [displayProperty]="'text'"
                                required="true"
                                name="type">
                    </app-select>
                    <ng-container [ngTemplateOutlet]="validation"
                                  [ngTemplateOutletContext]="{ validation: validations.type }">
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-8 form-field required">
                <label class="form-label">{{'notification_lblSender' | translate}}</label>
                <input class="form-control" [(ngModel)]="model.Sender" name="sender" required />
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.sender }">
                </ng-container>
            </div>

            <div class="col-sm-4 form-field required">
                <label class="form-label">{{'notification_lblSendingMethod' | translate}}</label>
                <app-select [(ngModel)]="model.SendingMethod"
                            [options]="options.sendingMethod"
                            [valueProperty]="'value'"
                            [displayProperty]="'text'"
                            required="true"
                            name="sendingMethod">
                </app-select>
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.sendingMethod }">
                </ng-container>
            </div>
        </div>

        <div class="row">
            <div class="col-sm form-field required">
                <label class="form-label">{{'notification_lblAvailableChannels' | translate}}</label>
                <div>
                    <div *ngFor="let n of options.channel">
                        <app-checkbox name="availableChannel_{{n.value}}" [(ngModel)]="availableChannels[n.value]"
                                      (stateChange)="onAvailableChannelChange(n.value, $event)">
                            {{n.text}}
                        </app-checkbox>
                    </div>
                </div>
                <ng-container [ngTemplateOutlet]="validation"
                              [ngTemplateOutletContext]="{ validation: validations.availableChannels }">
                </ng-container>
            </div>

            <div class="col-sm form-field">
                <label class="form-label">{{'notification_lblRequiredChannels' | translate}}</label>
                <div>
                    <div *ngFor="let n of options.channel">
                        <app-checkbox name="requiredChannel_{{n.value}}" [(ngModel)]="requiredChannels[n.value]"
                                      (stateChange)="onRequiredChannelChange(n.value, $event)">
                            {{n.text}}
                        </app-checkbox>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-field" [class.required]="isFullContentRequired">
            <label class="form-label">{{'notification_lblSubjectLV' | translate}}</label>
            <input class="form-control" [(ngModel)]="model.SubjectLV" name="subjectLV" [required]="isFullContentRequired" />
            <ng-container [ngTemplateOutlet]="validation"
                          [ngTemplateOutletContext]="{ validation: validations.subjectLV }">
            </ng-container>
        </div>

        <div class="form-field" [class.required]="isFullContentRequired">
            <label class="form-label">{{'notification_lblSubjectEN' | translate}}</label>
            <input class="form-control" [(ngModel)]="model.SubjectEN" name="subjectEN" [required]="isFullContentRequired" />
            <ng-container [ngTemplateOutlet]="validation"
                          [ngTemplateOutletContext]="{ validation: validations.subjectEN }">
            </ng-container>
        </div>

        <div class="form-field" [class.required]="isFullContentRequired">
            <label class="form-label">{{'notification_lblMessageLV' | translate}}</label>
            <editor [(ngModel)]="model.MessageLV" name="messageLV" [init]="textEditorConfig"></editor>
            <ng-container [ngTemplateOutlet]="validation"
                          [ngTemplateOutletContext]="{ validation: validations.messageLV }">
            </ng-container>
        </div>

        <div class="form-field" [class.required]="isFullContentRequired">
            <label class="form-label">{{'notification_lblMessageEN' | translate}}</label>
            <editor [(ngModel)]="model.MessageEN" name="messageEN" [init]="textEditorConfig"></editor>
            <ng-container [ngTemplateOutlet]="validation"
                          [ngTemplateOutletContext]="{ validation: validations.messageEN }">
            </ng-container>
        </div>

        <div class="form-field" [class.required]="isShortContentRequired">
            <label class="form-label">{{'notification_lblShortMessageLV' | translate}}</label>
            <textarea class="form-control" [(ngModel)]="model.ShortMessageLV" name="shortMessageLV" rows="3" [required]="isShortContentRequired"></textarea>
            <ng-container [ngTemplateOutlet]="validation"
                          [ngTemplateOutletContext]="{ validation: validations.shortMessageLV }">
            </ng-container>
        </div>

        <div class="form-field" [class.required]="isShortContentRequired">
            <label class="form-label">{{'notification_lblShortMessageEN' | translate}}</label>
            <textarea class="form-control" [(ngModel)]="model.ShortMessageEN" name="shortMessageEN" rows="3" [required]="isShortContentRequired"></textarea>
            <ng-container [ngTemplateOutlet]="validation"
                          [ngTemplateOutletContext]="{ validation: validations.shortMessageEN }">
            </ng-container>
        </div>

        <div class="form-actions">
            <button class="btn btn-outline" type="button" [routerLink]="['/notification-templates'] | localize">
                {{'close' | translate}}
            </button>

            <button class="btn btn-primary" type="button" (click)="save()">
                {{'save' | translate}}
            </button>
        </div>
    </form>
</div>

<ng-template #validation let-validation="validation">
    <ng-container *ngIf="isFormSubmitted">
        <div class="invalid-feedback" *ngFor="let e of getErrors(validation)">
            {{e}}
        </div>
    </ng-container>
</ng-template>
